<template>
  <footer class="d-print-none">

    <div class="container">

      <div class="row">

        <div class="col-4 col-sm-7">

          <a
            href="https://www.tntministries.org.uk/"
            target="_blank"
            rel="noopener"
            class="mb-4"
          >
            <img
              src="/images/tnt-logo.png"
              alt="TnT Logo"
              class="float-md-left me-5"
              loading="lazy"
            />
          </a>

          <p
            class="d-none d-md-block mt-4"
            v-html="rawHtml"
          ></p>

        </div>

        <div class="col-8 col-sm-5">

          <p class="text-end">
            <a
              href="https://www.tntministries.org.uk/"
              target="_blank"
              rel="noopener"
            >
              &copy; TnT Ministries {{ new Date().getFullYear() }}
            </a>

            <br />
            <a
              href="/license-agreement"
              :title="`Read the ${$t('footer.licenseAgreement')}`"
            >
              {{ $t("footer.licenseAgreement") }}
            </a>
            |
            <a
              href="/privacy-policy"
              :title="`Read the ${$t('footer.privacyPolicy')}`"
            >
              {{ $t("footer.privacyPolicy") }}
            </a>
            |
            <a
              href="/cookie-policy"
              :title="`Read the ${$t('footer.cookiePolicy')}`"
            >
              {{ $t("footer.cookiePolicy") }}
            </a>

            <br />

            <a
              href="https://handcodedstudio.co.uk/"
              target="_blank"
              rel="noopener"
              :title="`${$t('footer.websiteBy')} Hand Coded Studio`"
            >
              {{ $t("footer.websiteBy") }} Hand Coded Studio
            </a>
          </p>

        </div>

      </div>

    </div>

  </footer>
</template>

<script>
export default {
  name: "SiteFooter",

  data() {
    return {
      rawHtml: this.$t("home.footerText", ["<a href=\"https://www.tntministries.org.uk/\" target=\"_blank\" title=\"TnT Ministries website\">", "</a>"]),
    };
  },
};
</script>
